import { useTranslation } from 'react-i18next';

import { TimeInputLabels } from './types';

export const useTimeInputLabels = (): TimeInputLabels => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'common.timeInput',
  });

  return {
    placeholder: t('placeholder'),
    clear: t('clear'),
    hours: t('hours'),
    minutes: t('minutes'),
  };
};
